var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'answer-wrapper': true, 'answer-result-wrapper': _vm.result}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.image,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.answer.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-005f43ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/AnswerCalcCard.vue
// module id = Miu4
// module chunks = 0